(function () {
  function formatMoney(cents) {
    if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings && FoxTheme.settings.moneyFormat) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
    }
    return '' + (cents / 100).toFixed(2);
  }

  function strong(text) {
    const el = document.createElement('strong');
    el.textContent = text;
    return el;
  }

  function initVolumePricingCards(container) {
    if (container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    const quantityInput = document.getElementById(container.dataset.quantityInput);
    if (!quantityInput) return;

    const packOfValue = parseFloat(container.dataset.packOfValue) || 1;
    const basePrice = parseInt(container.dataset.basePrice, 10) || 0;
    const unitSingular = container.dataset.unitSingular || 'pack';
    const unitPlural = container.dataset.unitPlural || 'packs';
    const sectionId = container.dataset.sectionId;
    const cards = Array.from(container.querySelectorAll('.volume-pricing-card'));
    const nudgeEl = container.querySelector('[data-vp-nudge]');
    const totalUnitsEl = sectionId ? document.getElementById('TotalUnits-' + sectionId) : null;
    const totalLabelEl = totalUnitsEl && totalUnitsEl.parentElement
      ? totalUnitsEl.parentElement.querySelector('.volume-pricing-cards__summary-label')
      : null;
    const volumeEl = sectionId ? document.getElementById('ProductVolume-' + sectionId) : null;
    const bagVolume = volumeEl ? parseFloat(volumeEl.dataset.bagVolume) || 0 : 0;
    const subtotalEl = sectionId ? document.getElementById('ItemSubtotal-' + sectionId) : null;
    const priceContainer = sectionId ? document.getElementById('price-' + sectionId) : null;
    const priceEl = priceContainer ? priceContainer.querySelector('.f-price') : null;
    const regularPriceEl = priceContainer
      ? priceContainer.querySelector('.f-price__regular > .f-price-item--regular')
      : null;
    const salePriceEl = priceContainer
      ? priceContainer.querySelector('.f-price__sale > .f-price-item--sale')
      : null;
    const compareAtWrapperEl = priceContainer
      ? priceContainer.querySelector('.f-price__sale > .f-price-item--regular')
      : null;
    const incVatEl = priceContainer ? priceContainer.querySelector('[data-price-inc-vat]') : null;
    const saveEl = priceContainer ? priceContainer.querySelector('[data-price-save]') : null;
    const vatRate = priceEl ? parseFloat(priceEl.dataset.vatRate) || 0 : 0;
    const taxesIncluded = priceEl ? priceEl.dataset.taxesIncluded === 'true' : false;

    // Tier prices follow the store setting (ex VAT here). The main price shows ex VAT
    // and the line underneath shows the VAT-inclusive price; keep both in sync.
    function toDisplay(cents) {
      if (!vatRate || !taxesIncluded) return cents;
      return Math.round(cents / (1 + vatRate / 100));
    }

    function toIncVat(cents) {
      if (!vatRate || taxesIncluded) return cents;
      return Math.round(cents * (1 + vatRate / 100));
    }

    function updateMainPrice(unitPrice) {
      if (!priceEl) return;

      if (unitPrice < basePrice) {
        priceEl.classList.add('f-price--on-sale');
        if (salePriceEl) salePriceEl.textContent = formatMoney(toDisplay(unitPrice));
        // Theme price JS can replace the <s> inside the compare-at element, so write it whole.
        if (compareAtWrapperEl) compareAtWrapperEl.innerHTML = '<s>' + formatMoney(toDisplay(basePrice)) + '</s>';
        if (saveEl) saveEl.textContent = 'Save ' + Math.round(((basePrice - unitPrice) * 100) / basePrice) + '%';
      } else {
        priceEl.classList.remove('f-price--on-sale');
        if (regularPriceEl) regularPriceEl.textContent = formatMoney(toDisplay(unitPrice));
        if (saveEl) saveEl.textContent = '';
      }
      if (incVatEl) incVatEl.textContent = formatMoney(toIncVat(unitPrice));
    }

    // Hint under the cards: "Add 3 more packs to pay £4.50/pack and save 25%."
    // or, on the top tier, "Best price unlocked: you save 25% on every pack."
    function updateNudge(quantity) {
      if (!nudgeEl) return;
      const tiers = cards.map((card) => ({
        qty: parseInt(card.dataset.quantity, 10) || 1,
        price: parseInt(card.dataset.price, 10) || 0,
      }));
      const next = tiers.find((tier) => tier.qty > quantity && tier.price < basePrice);
      nudgeEl.textContent = '';
      if (next) {
        const more = next.qty - quantity;
        const percent = Math.round(((basePrice - next.price) * 100) / basePrice);
        nudgeEl.append(
          'Add ',
          strong(more + ' more ' + (more === 1 ? unitSingular : unitPlural)),
          ' to pay ',
          strong(formatMoney(toDisplay(next.price)) + '/' + unitSingular),
          ' and save ' + percent + '%.'
        );
      } else {
        const current = tiers.filter((tier) => quantity >= tier.qty).pop();
        const percent = current ? Math.round(((basePrice - current.price) * 100) / basePrice) : 0;
        if (percent > 0) {
          nudgeEl.append('Best price unlocked: you save ', strong(percent + '%'), ' on every ' + unitSingular + '.');
        }
      }
      nudgeEl.hidden = nudgeEl.textContent === '';
    }

    // With a bag volume set, the summary shows cubic feet instead of a bag count.
    function updateTotal(quantity) {
      if (!totalUnitsEl) return;
      if (bagVolume > 0) {
        totalUnitsEl.textContent = Math.round(quantity * bagVolume * 100) / 100 + ' cubic feet';
        if (totalLabelEl) totalLabelEl.textContent = 'Total volume';
      } else {
        totalUnitsEl.textContent = Math.round(quantity * packOfValue);
      }
    }

    function updateSummary(quantity, unitPrice) {
      updateTotal(quantity);
      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(quantity * unitPrice);
      }
      updateMainPrice(unitPrice);
      updateNudge(quantity);
    }

    function selectCard(card, options) {
      options = options || {};
      cards.forEach((c) => {
        c.classList.remove('is-selected');
        c.setAttribute('aria-checked', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-checked', 'true');

      const tierQuantity = parseInt(card.dataset.quantity, 10) || 1;
      const price = parseInt(card.dataset.price, 10) || 0;

      if (options.updateInput !== false) {
        quantityInput.value = tierQuantity;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateSummary(tierQuantity, price);
      } else {
        const actualQuantity = typeof options.quantity === 'number' ? options.quantity : tierQuantity;
        updateSummary(actualQuantity, price);
      }
    }

    cards.forEach((card) => {
      card.addEventListener('click', () => selectCard(card));
    });

    quantityInput.addEventListener('change', () => {
      const currentQty = parseInt(quantityInput.value, 10) || 1;
      let matchedCard = cards[0];
      cards.forEach((card) => {
        const cardQty = parseInt(card.dataset.quantity, 10) || 1;
        if (currentQty >= cardQty) {
          matchedCard = card;
        }
      });
      selectCard(matchedCard, { updateInput: false, quantity: currentQty });
    });

    updateTotal(parseInt(quantityInput.value, 10) || 1);
    updateNudge(parseInt(quantityInput.value, 10) || 1);
  }

  function initAll() {
    document.querySelectorAll('.volume-pricing-cards').forEach(initVolumePricingCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('variant:changed', initAll);
})();
